import { defineComponent as _defineComponent } from 'vue'
import CUIcon from "@/components/CUIcon.vue";
import { formatMinutesToHoursAndMinutes, timestampToCalendarDate } from "@/utils/datetime";

interface TripCardViewModel {
  label: string;
  tripName: string;
  reservationManagedId?: string;
  driversCount: number;
  vehiclesCount: number;
  scheduledDuration: number;
  tripDate: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TripCard',
  props: {
    label: null,
    tripName: null,
    reservationManagedId: null,
    driversCount: null,
    vehiclesCount: null,
    scheduledDuration: null,
    tripDate: null
  },
  setup(__props: any) {



return { __sfc: true,CUIcon, formatMinutesToHoursAndMinutes, timestampToCalendarDate }
}

})